
import MButton from "@/components/MButton.vue";
import MIcon from "@/components/MIcon.vue";
import MPrintInvitaion from "@/components/print_invitation/MPrintHeader.vue";
import { LoginInfo } from "@/store";
import { Options, Vue } from "vue-class-component";
import QrcodeVue from "qrcode.vue";
import { State } from "@/store/helper";

type DataType = {
  schoolName: string;
  studentName: string;
  loginId: string;
  schoolId: string;
  password: string;
  code: string;
};

@Options({
  components: {
    MButton,
    MIcon,
    MPrintInvitaion,
    QrcodeVue
  }
})
export default class PrintInvitation extends Vue {
  clipboardStatusType = "clipboard-copy";
  clipboardMessage = "招待文面をコピー";

  @State("selectedLoginInfos") loginInfos!: LoginInfo[];

  MINGAKU_GUIDE = "https://mingaku.net/guide-student";
  MINGAKU_APP_GUIDE = "https://mingaku.net/guide/mingaku_app_student";
  MINGAKU_ROOMS_GUIDE = "https://mingaku.net/guide/browser-usage";
  MINGAKU_APP_IOS =
    "https://apps.apple.com/jp/app/%E3%81%BF%E3%82%93%E3%81%8C%E3%81%8F/id6469667602";
  MINGAKU_APP_ANDROID =
    "https://play.google.com/store/apps/details?id=com.mingaku.mingakuapp&pli=1";

  get datas(): DataType[] {
    return this.loginInfos.map(info => {
      return {
        schoolName: info.schoolName,
        studentName: info.studentName,
        loginId: info.loginId,
        password: info.password,
        schoolId: info.schoolId,
        code: `${info.loginId} ${info.password} ${info.schoolId}`
      };
    });
  }

  async messageCopy() {
    const message = this.loginInfos
      .map(
        info => `ーーーーーーーー
「${info.studentName}（${info.schoolName}）」さん

”みんがく”にようこそ！
分からないことがあったら、公式ガイドを確認するか先生に相談しましょう。

▼みんがく公式ガイド
${this.MINGAKU_GUIDE}

・。・。・。・。・。・。・。・。・。・。・。・。・。・。

■ 「${info.studentName}（${info.schoolName}）」さんのログイン情報
・スクールID：${info.schoolId}
・ログインID：${info.loginId}
・パスワード：${info.password}
※ログイン時にコピー＆ペーストして使ってください。

■みんがく公式アプリ
・iPhoneの方
${this.MINGAKU_APP_IOS}
・Androidの方
${this.MINGAKU_APP_ANDROID}

■アプリ利用方法
${this.MINGAKU_APP_GUIDE}
■学習室の利用方法
${this.MINGAKU_ROOMS_GUIDE}
■みんがく公式ガイド
${this.MINGAKU_GUIDE}

・。・。・。・。・。・。・。・。・。・。・。・。・。・。

`
      )
      .join("\n\n\n\n");

    await navigator.clipboard.writeText(message);
    this.clipboardStatusType = "clipboard-check";
    this.clipboardMessage = "コピーしました";
    await new Promise(resolve => setTimeout(resolve, 1000));
    this.clipboardStatusType = "clipboard-copy";
    this.clipboardMessage = "招待文面をコピー";
  }

  print() {
    print();
  }

  shrinkTextToFit(element: HTMLElement): void {
    if (!element) {
      return;
    }
    let fontSize = parseInt(window.getComputedStyle(element).fontSize);
    const minFontSize = 1;
    while (
      element.scrollWidth > element.clientWidth &&
      fontSize > minFontSize
    ) {
      fontSize--;
      element.style.fontSize = `${fontSize}px`;
    }
  }

  created() {
    if (this.datas.length > 0) {
      let title = "みんがく帳票";
      this.datas.forEach(
        data => (title += `_${data.loginId} ${data.studentName}`)
      );
      document.title = title;
    }
  }

  mounted(): void {
    const containers: HTMLElement[] = Array.from(
      document.querySelectorAll(".textContainer")
    ) as HTMLElement[];

    containers.forEach(c => {
      this.shrinkTextToFit(c);
    });
  }
}
